module.exports = __webpack_public_path__ + "img/png-2.b9d36219.png";